import { useTranslation } from 'react-i18next';
import { S, Icon, EmptyState, formatDate } from '../../regureStyles';
import BordBadge from './BordBadge';

const BordereauxTab = ({
  carrier,
  bordereaux,
  loadingB,
  generating,
  genForm,
  setGenForm,
  showGenForm,
  setShowGenForm,
  sending,
  handleGenerate,
  handleDownload,
  handleSend,
}) => {
  const { t } = useTranslation();
  const headers = [
    t('screens.riskCarriers.bordColPeriod',    { defaultValue: 'Period' }),
    t('screens.riskCarriers.bordColType',      { defaultValue: 'Type' }),
    t('screens.riskCarriers.bordColFormat',    { defaultValue: 'Format' }),
    t('screens.riskCarriers.bordColRows',      { defaultValue: 'Rows' }),
    t('screens.riskCarriers.bordColFileSize',  { defaultValue: 'File Size' }),
    t('screens.riskCarriers.bordColGenerated', { defaultValue: 'Generated' }),
    t('screens.riskCarriers.bordColStatus',    { defaultValue: 'Status' }),
    t('screens.riskCarriers.bordColActions',   { defaultValue: 'Actions' }),
  ];
  return (
    <div>
      {/* Generate bar */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: S.textPrimary }}>{t('screens.riskCarriers.bordHistoryTitle', { defaultValue: 'Bordereaux History' })}</div>
          <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{t('screens.riskCarriers.bordHistorySubtitle', { name: carrier.name, defaultValue: 'All generated reports for {{name}}' })}</div>
        </div>
        <button
          onClick={() => setShowGenForm(v => !v)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '9px 18px',
            background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          <Icon name='plus' color='#fff' size={16} /> {t('screens.riskCarriers.bordGenerateReport', { defaultValue: 'Generate Report' })}
        </button>
      </div>

      {/* Generate form */}
      {showGenForm && (
        <div style={{ background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 14, padding: 20, marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: S.textPrimary, marginBottom: 14 }}>{t('screens.riskCarriers.bordGenerateNew', { defaultValue: 'Generate New Bordereaux' })}</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 12, alignItems: 'flex-end' }}>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>{t('screens.riskCarriers.bordReportType', { defaultValue: 'Report Type' })}</div>
              <select
                value={genForm.type}
                onChange={e => setGenForm(f => ({ ...f, type: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '9px 12px',
                  background: S.bgCard,
                  border: `1px solid ${S.borderLight}`,
                  borderRadius: 8,
                  fontSize: 13,
                  color: S.textPrimary,
                  outline: 'none',
                }}
              >
                <option value='claims'>{t('screens.riskCarriers.bordTypeClaims',   { defaultValue: 'Claims Bordereaux' })}</option>
                <option value='premium'>{t('screens.riskCarriers.bordTypePremium', { defaultValue: 'Premium Bordereaux' })}</option>
                <option value='combined'>{t('screens.riskCarriers.bordTypeCombined',{ defaultValue: 'Combined' })}</option>
                <option value='loss_run'>{t('screens.riskCarriers.bordTypeLossRun', { defaultValue: 'Loss Run' })}</option>
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>{t('screens.riskCarriers.bordPeriodFrom', { defaultValue: 'Period From' })}</div>
              <input
                type='date'
                value={genForm.from}
                onChange={e => setGenForm(f => ({ ...f, from: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '9px 12px',
                  background: S.bgCard,
                  border: `1px solid ${S.borderLight}`,
                  borderRadius: 8,
                  fontSize: 13,
                  color: S.textPrimary,
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 5 }}>{t('screens.riskCarriers.bordPeriodTo', { defaultValue: 'Period To' })}</div>
              <input
                type='date'
                value={genForm.to}
                onChange={e => setGenForm(f => ({ ...f, to: e.target.value }))}
                style={{
                  width: '100%',
                  padding: '9px 12px',
                  background: S.bgCard,
                  border: `1px solid ${S.borderLight}`,
                  borderRadius: 8,
                  fontSize: 13,
                  color: S.textPrimary,
                  outline: 'none',
                  boxSizing: 'border-box',
                }}
              />
            </div>
            <button
              onClick={handleGenerate}
              disabled={generating}
              style={{
                padding: '9px 20px',
                background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                opacity: generating ? 0.6 : 1,
                whiteSpace: 'nowrap',
              }}
            >
              {generating ? t('screens.riskCarriers.bordBtnGenerating', { defaultValue: 'Generating…' }) : t('screens.riskCarriers.bordBtnGenerate', { defaultValue: 'Generate' })}
            </button>
          </div>
        </div>
      )}

      {/* Bordereaux table */}
      {loadingB ? (
        <div style={{ padding: 60, textAlign: 'center', color: S.textMuted }}>{t('screens.riskCarriers.bordLoading', { defaultValue: 'Loading bordereaux…' })}</div>
      ) : bordereaux.length === 0 ? (
        <EmptyState icon='file-text' title={t('screens.riskCarriers.bordEmptyTitle', { defaultValue: 'No bordereaux yet' })} subtitle={t('screens.riskCarriers.bordEmptySubtitle', { defaultValue: "Click 'Generate Report' to create the first one." })} />
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {headers.map(h => (
                <th
                  key={h}
                  style={{
                    padding: '11px 14px',
                    textAlign: 'left',
                    fontSize: 11,
                    fontWeight: 700,
                    color: S.textMuted,
                    textTransform: 'uppercase',
                    letterSpacing: 0.8,
                    borderBottom: `2px solid ${S.borderLight}`,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {bordereaux.map((b, i) => {
              const from = b.period?.from ? formatDate(b.period.from) : '—';
              const to = b.period?.to ? formatDate(b.period.to) : '—';
              const sizeKb = b.fileSize ? Math.round(b.fileSize / 1024) : null;
              return (
                <tr key={b._id} style={{ borderBottom: `1px solid ${S.borderLight}`, background: i % 2 === 0 ? '#fff' : S.bgCard }}>
                  <td style={{ padding: '12px 14px', fontSize: 13, fontWeight: 500, color: S.textPrimary }}>
                    {from} — {to}
                  </td>
                  <td style={{ padding: '12px 14px', fontSize: 13, color: S.textSecondary, textTransform: 'capitalize' }}>{b.type?.replace('_', ' ')}</td>
                  <td style={{ padding: '12px 14px', fontSize: 12, fontWeight: 700, color: S.textMuted, fontFamily: 'monospace' }}>
                    {(b.format || 'xlsx').toUpperCase()}
                  </td>
                  <td style={{ padding: '12px 14px', fontSize: 13, color: S.textPrimary }}>{b.rowCount ?? '—'}</td>
                  <td style={{ padding: '12px 14px', fontSize: 12, color: S.textMuted }}>{sizeKb != null ? `${sizeKb} KB` : '—'}</td>
                  <td style={{ padding: '12px 14px', fontSize: 12, color: S.textMuted }}>
                    {b.createdAt ? new Date(b.createdAt).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—'}
                  </td>
                  <td style={{ padding: '12px 14px' }}>
                    <BordBadge status={b.status} />
                  </td>
                  <td style={{ padding: '12px 14px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      {b.status === 'ready' || b.status === 'sent' || b.status === 'acknowledged' ? (
                        <>
                          <button
                            onClick={() => handleDownload(b._id, b.format)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 4,
                              padding: '5px 11px',
                              background: S.bgCard,
                              border: `1px solid ${S.borderLight}`,
                              borderRadius: 6,
                              fontSize: 11,
                              fontWeight: 600,
                              color: S.textSecondary,
                              cursor: 'pointer',
                            }}
                          >
                            <Icon name='download' color={S.textMuted} size={12} /> {t('screens.riskCarriers.bordActionDownload', { defaultValue: 'Download' })}
                          </button>
                          {b.status !== 'sent' && b.status !== 'acknowledged' && (
                            <button
                              onClick={() => handleSend(b._id)}
                              disabled={sending === b._id}
                              style={{
                                padding: '5px 11px',
                                background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
                                color: '#fff',
                                border: 'none',
                                borderRadius: 6,
                                fontSize: 11,
                                fontWeight: 600,
                                cursor: 'pointer',
                                opacity: sending === b._id ? 0.6 : 1,
                              }}
                            >
                              {sending === b._id ? t('screens.riskCarriers.bordActionSending', { defaultValue: '…' }) : t('screens.riskCarriers.bordActionSend', { defaultValue: 'Send' })}
                            </button>
                          )}
                        </>
                      ) : b.status === 'generating' ? (
                        <span style={{ fontSize: 12, color: '#7c3aed' }}>{t('screens.riskCarriers.bordActionGenerating', { defaultValue: 'Generating…' })}</span>
                      ) : b.status === 'error' ? (
                        <span style={{ fontSize: 12, color: S.danger }}>{t('screens.riskCarriers.bordActionError', { defaultValue: 'Error' })}</span>
                      ) : null}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BordereauxTab;
